<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
            <el-form-item label="拼团ID">
<!--                <el-input style="width: 177px;" v-model="queryForm.groupbuyId"></el-input>-->
                <GridSelectU style="width: 177px;" labelName="productName"
                             labelValue="id" :value="queryForm.groupbuyId" :limit='1' size='small' placeholder='请选择所属拼团'
                             @getValue="getSearchShopProduct" :columns="SHOPPRODUCTGROUPBUY_code" :searchs="SHOPPRODUCTGROUPBUY_search" dataListUrl="/shop/productgroupbuy/findList" entityBeanName="shopProductGroupbuy" queryEntityUrl="/shop/productgroupbuy/get">
                </GridSelectU>
            </el-form-item>
            <el-form-item label="团长ID">
<!--                <el-input  v-model="queryForm.leaderId"></el-input>-->
                <GridSelectU style="width: 177px;" labelName="userName"
                     labelValue="id" :value="queryForm.leaderId" :limit='1' size='small' placeholder='请选择用户'
                     @getValue="getSearchUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                </GridSelectU>
            </el-form-item>
            <el-form-item label="参团人数">
                <el-input style="width: 177px;" v-model="queryForm.joinNumber"></el-input>
            </el-form-item>
            <el-form-item label="拼团状态">
<!--                <el-input style="width: 177px;" v-model="queryForm.status"></el-input>-->
                <el-select
                    placeholder='拼团状态'
                    clearable
                    style='width: 177px'
                    size='small'
                    v-model='queryForm.status'
                >
                    <el-option
                        :label='"已取消"'
                        :value='0'
                    >
                    </el-option>
                    <el-option
                        :label='"进行中"'
                        :value='1'
                    >
                    </el-option>
                    <el-option
                        :label='"待成团"'
                        :value='2'
                    >
                    </el-option>
                    <el-option
                        :label='"拼团成功"'
                        :value='3'
                    >
                    </el-option>
                    <el-option
                        :label='"拼团失败"'
                        :value='4'
                    >
                    </el-option>
                </el-select>
            </el-form-item>
<!--            <el-form-item label="结束时间">-->
<!--                <el-input style="width: 177px;" v-model="queryForm.endTime"></el-input>-->
<!--            </el-form-item>-->
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getShopProductGroupbuyGroupList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
<!--                    <el-button-->
<!--                        type="primary"-->
<!--                        size="small"-->
<!--                        icon="el-icon-plus"-->
<!--                        @click="addShopProductGroupbuyGroup"-->
<!--                    >新建</el-button>-->
<!--                    <el-button-->
<!--                        type="warning"-->
<!--                        plain-->
<!--                        size="small"-->
<!--                        icon="el-icon-edit"-->
<!--                        :disabled="multipleSelection.length != 1"-->
<!--                        @click="editShopProductGroupbuyGroup(null)"-->
<!--                    >修改</el-button>-->
<!--                    <el-button-->
<!--                        type="danger"-->
<!--                        plain-->
<!--                        size="small"-->
<!--                        icon="el-icon-delete"-->
<!--                        :disabled="multipleSelection.length <= 0"-->
<!--                        @click="deleteShopProductGroupbuyGroup(null)"-->
<!--                    >删除</el-button>-->
                </div>

                <div class="icon-group">
                    <el-upload v-if="this.isImportDate"
                               class="upload-demo"
                               action="#"
                               :http-request="upload"
                               :show-file-list="true">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
                    <span
                        title="搜索"
                        class="icon-box"
                        @click="search"
                    >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
                    <span
                        title="下载模板"
                        class="icon-box"
                        @click="importTemplate"
                    >
          <Icon color="#606266">
            <ArrowDown />
          </Icon>
        </span>
                    <span
                        class="icon-box"
                        title="导入数据"
                        @click="isImport"
                    >
          <Icon color="#606266">
            <ArrowExportUp24Regular />
          </Icon>
        </span>
                    <span
                        title="导出数据"
                        class="icon-box"
                        @click="exportShopProductGroupbuyGroupList"
                    >
          <Icon color="#606266">
            <ArrowDownload24Regular />
          </Icon>
        </span>
                    <span
                        class="icon-box"
                        @click="refreshShopProductGroupbuyGroupList"
                    >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :data="shopProductGroupbuyGroupList"
                row-key="id"
                border
                height="100%"
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                @selection-change="handleSelectionChange"
                size="small"
            >
                <el-table-column
                    align="center"
                    type="selection"
                    width="60"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="groupbuyId"
                    label="拼团ID"
                    width="300"
                >
                    <template slot-scope="scope" v-if='scope.row.shopProductGroupbuy'>
                        <div style="display: flex">
                            <div style="">
                                <el-image @click='updateSrcList(scope.row.shopProductGroupbuy.productPic)' style="width: 50px; height: 50px"
                                          :src="scope.row.shopProductGroupbuy.productPic" :preview-src-list="srcList"></el-image>
                            </div>
                            <div style="margin-left: 10px">
                                <div style="text-align: left">商品名称：{{ scope.row.shopProductGroupbuy.productName }}</div>
                                <div style="text-align: left">商品价格：{{ scope.row.shopProductGroupbuy.groupbuyPrice }}</div>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="leaderId"
                    label="团长ID"
                    width="180"
                >
                    <template slot-scope="scope" v-if='scope.row.user'>
                        <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                        <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                        <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                    </template>
                    <template slot-scope="scope" v-else>
                        <div>暂无关联用户</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="joinNumber"
                    label="参团人数/成团人数"
                    width="180"
                >
                    <template slot-scope="scop">
                        {{scop.row.joinNumber}}/{{scop.row.shopProductGroupbuy.groupNumber}}
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="status"
                    label="拼团状态"
                    width="180"
                >
                    <template slot-scope="scop">
                        {{returnStatus(scop.row.status)}}
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="endTime"
                    label="结束时间"
                    width="180"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="createTime"
                    label="创建时间"
                    width="180"
                > </el-table-column>
                <el-table-column
                    fixed="right"
                    align="center"
                    label="操作"
                    width="300"
                >
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click="showCardUser(scop.row.id)">
                                <span class="operation-label">参团详情</span>
                            </div>
                            <div @click="checkShopProductGroupbuyGroup(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">查看</span>
                            </div>
<!--                            <div @click="editShopProductGroupbuyGroup(scop.row.id)">-->
<!--                                <Icon size="16">-->
<!--                                    <Edit24Regular />-->
<!--                                </Icon>-->
<!--                                <span class="operation-label">修改</span>-->
<!--                            </div>-->
<!--                            <div @click="deleteShopProductGroupbuyGroup(scop.row.id)">-->
<!--                                <Icon size="16" style="color: red">-->
<!--                                    <Delete24Regular />-->
<!--                                </Icon>-->
<!--                                <span class="operation-label" style="color: red">删除</span>-->
<!--                            </div>-->
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title="shopProductGroupbuyGroupStates[shopProductGroupbuyGroupState]"
                :visible.sync="showDialog"
                width="60%"
                @close="closeDialog"
            >
                <div>
                    <el-form
                        :model="shopProductGroupbuyGroup"
                        ref="shopProductGroupbuyGroupForm"
                        :rules="rules"
                        label-width="120px"
                        :inline="true"
                        size="small"
                    >
                        <el-form-item
                            label="拼团ID"
                            prop="groupbuyId"
                        >
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                style="width: 177px;"-->
<!--                                v-model="shopProductGroupbuyGroup.groupbuyId"-->
<!--                                :disabled="shopProductGroupbuyGroupState == 'check'"-->
<!--                            ></el-input>-->
                            <GridSelectU style="width: 177px;" labelName="productName" :disabled="shopProductGroupbuyGroupState == 'check'"
                                 labelValue="id" :value="shopProductGroupbuyGroup.groupbuyId" :limit='1' size='small' placeholder='请选择所属拼团'
                                 @getValue="getValueShopProduct" :columns="SHOPPRODUCTGROUPBUY_code" :searchs="SHOPPRODUCTGROUPBUY_search" dataListUrl="/shop/productgroupbuy/findList" entityBeanName="shopProductGroupbuy" queryEntityUrl="/shop/productgroupbuy/get">
                            </GridSelectU>
                        </el-form-item>
                        <el-form-item
                            label="团长ID"
                            prop="leaderId"
                        >
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                v-model="shopProductGroupbuyGroup.leaderId"-->
<!--                                :disabled="shopProductGroupbuyGroupState == 'check'"-->
<!--                            ></el-input>-->
                            <GridSelectU style="width: 177px;" labelName="userName" :disabled="shopProductGroupbuyGroupState == 'check'"
                                 labelValue="id" :value="shopProductGroupbuyGroup.leaderId" :limit='1' size='small' placeholder='请选择用户'
                                 @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                            </GridSelectU>
                        </el-form-item>
                        <el-form-item
                            label="参团人数"
                            prop="joinNumber"
                        >
                            <el-input
                                size="small"
                                style="width: 177px;"
                                v-model="shopProductGroupbuyGroup.joinNumber"
                                :disabled="shopProductGroupbuyGroupState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="拼团状态"
                            prop="status"
                        >
<!--                            <el-input-->
<!--                                size="small"-->
<!--                                style="width: 177px;"-->
<!--                                v-model="shopProductGroupbuyGroup.status"-->
<!--                                :disabled="shopProductGroupbuyGroupState == 'check'"-->
<!--                            ></el-input>-->
                            <el-select
                                placeholder='请选择拼团状态'
                                clearable
                                style='width: 177px'
                                size='small'
                                v-model='shopProductGroupbuyGroup.status'
                                :disabled="shopProductGroupbuyGroupState == 'check'"
                            >
                                <el-option
                                    :label='"已取消"'
                                    :value='0'
                                >
                                </el-option>
                                <el-option
                                    :label='"进行中"'
                                    :value='1'
                                >
                                </el-option>
                                <el-option
                                    :label='"待成团"'
                                    :value='2'
                                >
                                </el-option>
                                <el-option
                                    :label='"拼团成功"'
                                    :value='3'
                                >
                                </el-option>
                                <el-option
                                    :label='"拼团失败"'
                                    :value='4'
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label="结束时间"
                            prop="endTime"
                        >
                            <el-input
                                size="small"
                                style="width: 177px;"
                                v-model="shopProductGroupbuyGroup.endTime"
                                :disabled="shopProductGroupbuyGroupState == 'check'"
                            ></el-input>
                        </el-form-item>
                    </el-form>
                </div>

                <div
                    slot="footer"
                    class="flex justify-end"
                >
                    <el-button @click="closeDialog">关闭</el-button>
                    <el-button
                        type="primary"
                        @click="submitForm"
                        v-if="shopProductGroupbuyGroupState != 'check'"
                    >确定</el-button>
                </div>
            </el-dialog>
        </div>
        <el-drawer
            title="参团详情"
            :visible.sync="cardUserStatus"
            direction="rtl"
            size="70%"
            :before-close="cardUserClose">
            <ShopProductGroupbuyGroupRecord ref="shopUse"></ShopProductGroupbuyGroupRecord>
        </el-drawer>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import ShopProductGroupbuyGroupRecord from '@/components/shop/ShopProductGroupbuyGroupRecord.vue';
import GridSelectU from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH, SHOPPRODUCTGROUPBUY, SHOPPRODUCTGROUPBUY_SEARCH } from '@/utils/constant';

export default {
    components: {
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        ShopProductGroupbuyGroupRecord
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetShopProductGroupbuyGroupList();
                this.getShopProductGroupbuyGroupList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetShopProductGroupbuyGroupList();
                this.getShopProductGroupbuyGroupList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            cardUserStatus: false,
            USER_code: USER,
            USER_search: USER_SEARCH,
            SHOPPRODUCTGROUPBUY_code: SHOPPRODUCTGROUPBUY,
            SHOPPRODUCTGROUPBUY_search: SHOPPRODUCTGROUPBUY_SEARCH,
            queryForm:{
                groupbuyId: '', //拼团ID
                leaderId: '', //团长ID
                joinNumber: '', //参团人数
                status: '', //拼团状态
                endTime: '', //结束时间
            },
            srcList: [""],
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            shopProductGroupbuyGroupState: 'add',
            shopProductGroupbuyGroupStates: {
                add: '新建拼团详情',
                check: '查看拼团详情',
                edit: '修改拼团详情'
            },

            multipleSelection: [],
            shopProductGroupbuyGroupList: [],
            shopProductGroupbuyGroup: {
                id: '', //ID
                groupbuyId: '', //拼团ID
                leaderId: '', //团长ID
                joinNumber: '', //参团人数
                status: '', //拼团状态
                endTime: '', //结束时间
            },
            btnLoading: false,

            rules: {
                groupbuyId: [{ required: true, message: '拼团ID不能为空', trigger: 'blur' }],
                leaderId: [{ required: true, message: '团长ID不能为空', trigger: 'blur' }],
                joinNumber: [{ required: true, message: '参团人数不能为空', trigger: 'blur' }],
                status: [{ required: true, message: '拼团状态不能为空', trigger: 'blur' }],
                endTime: [{ required: true, message: '结束时间不能为空', trigger: 'blur' }],
            }
        };
    },
    created() {
        this.getShopProductGroupbuyGroupList();
    },
    methods: {
        getValueUser(value) {
            this.shopProductGroupbuyGroup.leaderId = value
        },
        getSearchUser(value){
            this.queryForm.leaderId = value;
        },
        updateSrcList(src){
            this.srcList[0] = src;
        },
        getValueShopProduct(value) {
            this.shopProductGroupbuyGroup.groupbuyId = value
        },
        getSearchShopProduct(value){
            this.queryForm.groupbuyId = value;
        },
        showCardUser(id){
            this.cardUserStatus = true
            this.$nextTick(()=>{
                this.$refs.shopUse.show(id)
            })
        },
        cardUserClose(){
            this.cardUserStatus = false
        },
        search(){
            this.isSearch = !this.isSearch;
        },
        resetShopProductGroupbuyGroupList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.shopProductGroupbuyGroupList = [];
        },
        returnStatus(status){
            let statusList = [
                {
                    key: '0',
                    value: '已取消'
                },
                {
                    key: '1',
                    value: '进行中'
                },
                {
                    key: '2',
                    value: '待成团'
                },
                {
                    key: '3',
                    value: '拼团成功'
                },
                {
                    key: '4',
                    value: '拼团失败'
                }
            ]
            return statusList.find(item => item.key == status).value
        },
        resetDialog() {
            this.shopProductGroupbuyGroupState = 'add';
            this.showDialog = false;
            this.queryForm = {
                groupbuyId: '', //拼团ID
                leaderId: '', //团长ID
                joinNumber: '', //参团人数
                status: '', //拼团状态
                endTime: '', //结束时间
            };
            this.getShopProductGroupbuyGroupList();
        },
        closeDialog() {
            this.showDialog = false
            this.shopProductGroupbuyGroup = {
                id: '', //ID
                groupbuyId: '', //拼团ID
                leaderId: '', //团长ID
                joinNumber: '', //参团人数
                status: '', //拼团状态
                endTime: '', //结束时间
            };
        },
        submitForm() {
            if (this.shopProductGroupbuyGroupState == 'add') {
                this.$refs.shopProductGroupbuyGroupForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/shop/productgroupbuygroup/add`,{ ...this.shopProductGroupbuyGroup }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000,
                                });
                                this.resetShopProductGroupbuyGroupList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            } else if (this.shopProductGroupbuyGroupState == 'edit') {
                this.$refs.shopProductGroupbuyGroupForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/shop/productgroupbuygroup/edit`,{ ...this.shopProductGroupbuyGroup }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopProductGroupbuyGroupList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            }
        },
        addShopProductGroupbuyGroup() {
            this.showDialog = true;
            this.shopProductGroupbuyGroupState = 'add';
        },
        checkShopProductGroupbuyGroup(shopProductGroupbuyGroupId) {
            console.log(shopProductGroupbuyGroupId);
            this.currentShopProductGroupbuyGroupId = shopProductGroupbuyGroupId;

            this.getShopProductGroupbuyGroupById();
            this.showDialog = true;
            this.shopProductGroupbuyGroupState = 'check';
        },
        editShopProductGroupbuyGroup(shopProductGroupbuyGroupId) {
            console.log('shopProductGroupbuyGroup', shopProductGroupbuyGroupId);
            if (shopProductGroupbuyGroupId) {
                this.currentShopProductGroupbuyGroupId = shopProductGroupbuyGroupId;
                this.getShopProductGroupbuyGroupById();
            } else {
                this.shopProductGroupbuyGroup = { ...this.shopProductGroupbuyGroup, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.shopProductGroupbuyGroupState = 'edit';
        },
        deleteShopProductGroupbuyGroup(shopProductGroupbuyGroupId) {
            let ids = '';
            if (shopProductGroupbuyGroupId) {
                ids = shopProductGroupbuyGroupId;
            } else {
                ids = this.multipleSelection.map((shopProductGroupbuyGroup) => shopProductGroupbuyGroup.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/shop/productgroupbuygroup/delete`,{ ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetShopProductGroupbuyGroupList();
                            this.getShopProductGroupbuyGroupList();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                })
                .catch(() => {});
        },
        refreshShopProductGroupbuyGroupList() {
            this.resetShopProductGroupbuyGroupList();
            this.getShopProductGroupbuyGroupList();
        },
        getShopProductGroupbuyGroupList(query = {}) {
            this.loading = true;
            get(`/shop/productgroupbuygroup/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.shopProductGroupbuyGroupList = res.page.list;
                    this.totalNum = res.page.total;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        getShopProductGroupbuyGroupById() {
            get(`/shop/productgroupbuygroup/get`,{ id: this.currentShopProductGroupbuyGroupId }).then((res) =>{
                if(res.success){
                    this.shopProductGroupbuyGroup = { ...this.shopProductGroupbuyGroup, ...res.shopProductGroupbuyGroup };
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        /**
         * 导出信息
         */
        exportShopProductGroupbuyGroupList() {
            //this.btnLoading = true;
            exprotExcel(`/shop/productgroupbuygroup/export`, {...this.queryForm});
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/shop/productgroupbuygroup/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params){
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/shop/productgroupbuygroup/importData`,formData);
            this.refreshShopProductGroupbuyGroupList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getShopProductGroupbuyGroupList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getShopProductGroupbuyGroupList();
        }
    }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>